import { render, staticRenderFns } from "./RecommendedProduct.vue?vue&type=template&id=03702f3c&scoped=true"
import script from "./RecommendedProduct.vue?vue&type=script&lang=js"
export * from "./RecommendedProduct.vue?vue&type=script&lang=js"
import style0 from "./RecommendedProduct.vue?vue&type=style&index=0&id=03702f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03702f3c",
  null
  
)

export default component.exports